module.exports = __webpack_public_path__ + "img/logo-mazzitech.7d3a4faf.svg";